<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">帮助</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container style="padding:0;">
        <v-list style="padding-bottom:0rem;padding-top:0rem;">
            <v-list-item @click="goHelpLoginPc">
                <v-list-item-content>
                    <v-list-item-title>电脑端登录</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon color="grey">fa fa-angle-right</v-icon>
                </v-list-item-icon>
            </v-list-item>
            <v-list-item @click="goHelpBindDevice">
                <v-list-item-content>
                    <v-list-item-title>绑定主机设备</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-icon color="grey">fa fa-angle-right</v-icon>
                </v-list-item-icon>
            </v-list-item>
        </v-list>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {}
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    goHelpLoginPc() {
      this.$router.goPage('/HelpLoginPc')
    },
    goHelpBindDevice() {
      this.$router.goPage('/HelpBindDevice')
    }
  }
}
</script>

<style scoped>
.us_list_item{
  min-height:2.6rem;
  max-height:3rem;
  padding-right:0.15rem;
  padding-left:1.5rem;
}
</style>

